import React from 'react';
import { motion } from 'framer-motion';
import { Radio } from 'lucide-react';
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import L from 'leaflet';

// --- Fix for Leaflet Default Icons ---
import icon from 'leaflet/dist/images/marker-icon.png';
import iconShadow from 'leaflet/dist/images/marker-shadow.png';

let DefaultIcon = L.icon({
    iconUrl: icon,
    shadowUrl: iconShadow,
    iconSize: [25, 41],
    iconAnchor: [12, 41],
    popupAnchor: [1, -34]
});
L.Marker.prototype.options.icon = DefaultIcon;

// --- UPDATED EXACT LOCATION DATA ---
const locations = [
  // --- Head Office ---
  { id: 1, name: "Pune (HQ)", lat: 18.5204, lng: 73.8567, type: "Head Office" },

  // --- International ---
  { id: 2, name: "South Africa", lat: -30.5595, lng: 22.9375, type: "International" },
  { id: 3, name: "Bhutan", lat: 27.5142, lng: 90.4336, type: "International" },

  // --- North East India ---
  { id: 4, name: "Manipur", lat: 24.6637, lng: 93.9063, type: "North East" },
  { id: 5, name: "Assam", lat: 26.2006, lng: 92.9376, type: "North East" },
  { id: 6, name: "Tripura", lat: 23.9408, lng: 91.9882, type: "North East" },
  { id: 7, name: "Arunachal Pradesh", lat: 28.2180, lng: 94.7278, type: "North East" },

  // --- North India ---
  { id: 8, name: "Punjab", lat: 31.1471, lng: 75.3412, type: "North India" },
  { id: 9, name: "Rajasthan", lat: 27.0238, lng: 74.2179, type: "North India" },
  { id: 10, name: "Delhi", lat: 28.7041, lng: 77.1025, type: "North India" },
  { id: 11, name: "Haryana", lat: 29.0588, lng: 76.0856, type: "North India" },
  { id: 12, name: "Uttar Pradesh", lat: 26.8467, lng: 80.9462, type: "North India" },
];

const NetworkMap = () => {
  return (
    <section className="w-full py-24 bg-slate-50 overflow-hidden relative border-t border-slate-200 flex flex-col items-center justify-center">
      
      <div className="container mx-auto px-6 relative z-10 flex flex-col items-center">
        
        {/* --- HEADING SECTION --- */}
        <div className="text-center mb-12">
           <motion.div 
             initial={{ opacity: 0, y: -20 }}
             whileInView={{ opacity: 1, y: 0 }}
             viewport={{ once: true }}
             className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-blue-50 border border-blue-200 text-blue-700 text-xs font-bold uppercase tracking-widest mb-4 shadow-sm"
           >
             <Radio size={14} className="animate-pulse text-red-500" />
             <span>Global & Pan-India Presence</span>
           </motion.div>

           <motion.h2 
             initial={{ opacity: 0, y: 20 }}
             whileInView={{ opacity: 1, y: 0 }}
             viewport={{ once: true }}
             transition={{ delay: 0.1 }}
             className="text-4xl lg:text-5xl font-bold text-slate-900 leading-tight"
           >
             Sterility Delivered <br/>
             <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-600 to-sky-600">
               Across Borders.
             </span>
           </motion.h2>
        </div>

        {/* --- MAP CONTAINER --- */}
        <motion.div 
          initial={{ opacity: 0, scale: 0.9 }}
          whileInView={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.5 }}
          className="relative w-full h-[500px] lg:h-[600px] rounded-2xl overflow-hidden shadow-2xl border-4 border-white"
        >
            <MapContainer 
                center={[23.0, 82.0]} // Center adjust kiya taki India pura dikhe
                zoom={4} // Zoom level set kiya
                style={{ height: "100%", width: "100%" }}
                scrollWheelZoom={false}
            >
                <TileLayer
                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                attribution='&copy; OpenStreetMap contributors'
                />

                {locations.map((loc, index) => (
                <Marker key={index} position={[loc.lat, loc.lng]}>
                    <Popup>
                        <div className="text-center min-w-[120px]">
                            <h3 className="font-bold text-blue-700 m-0 text-sm">{loc.name}</h3>
                            <span className="text-[10px] bg-slate-100 px-2 py-0.5 rounded mt-1 inline-block border border-slate-300">
                                {loc.type}
                            </span>
                        </div>
                    </Popup>
                </Marker>
                ))}
            </MapContainer>

            {/* Glossy Overlay Effect */}
            <div className="absolute inset-0 pointer-events-none border-2 border-white/20 rounded-2xl shadow-[inset_0_0_40px_rgba(0,0,0,0.1)]"></div>
        </motion.div>

      </div>
    </section>
  );
};

export default NetworkMap;